var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
var ToggleButtonGroup = function (props) {
    return React.createElement(MuiToggleButtonGroup, __assign({}, props));
};
ToggleButtonGroup.defaultProps = {};
ToggleButtonGroup.displayName = 'KareoToggleButtonGroup';
export default ToggleButtonGroup;
